import { push } from 'svelte-spa-router';
import { addToast } from './components/custom/Toasts/store';
import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';

export function changeToken(status=401){  
  if (status === 401){
    push(`/token_error/`)
  }
  
  if (status === 403) {
    push(`/access_error/`)
    addToast(get(_)('accessMessage'));
  }

  if (status === 404) {
    push('/404');
  }
}
